import React, { useEffect, useState, useRef } from "react";
import style from "./cargoModalTab.module.scss";
import CheckBox from "../../SelectionControls/Checkbox/Checkbox";
import RadioButton from "../../EditRadioButton/RadioButton";
import DropDown from "../../Dropdown/SimpleDropDown/DropDown";
import { warehouses, shippingCommitment, createPackageFrequency, daysOfWeek, deliverTimeRange, deliverType } from '../../../helpers/consts/cargoConsts'
import Button from "../../Button/button";
import TimeCard from "./timeCard"
import Tooltip from "../../tooltip/tooltip"
import { useDrop } from 'react-dnd'
import toPersianNumber from "../../../helpers/actions/toPersianNumber";


const CargoModalTab = (props) => {

    let nameInput = ['', '', '', '', '']

    const [{ isOver }, addToTimeRangeRef] = useDrop({
        accept: "allTimeRange",
        collect: (monitor) => ({
            isOver: !!monitor.isOver()
        })
    })

    const [{ isOver: isTimeRangeOver }, removeFromTimeRangeRef] = useDrop({
        accept: "selectedTimeRange",
        collect: (monitor) => ({
            isOver: !!monitor.isOver()
        })
    })

    const moveTimeRange = item => {
        let tmp = modalData
        if (item && item.type == 'allTimeRange') {
            // accepting  time Range and put it in selectedTimeRange then remove it from allTimeRange
            tmp.selectedTimeRange = [...tmp.selectedTimeRange, item];
            tmp.allTimeRange = tmp.allTimeRange.filter(el => el.id !== item.id)
        }
        if (item && item.type == 'selectedTimeRange') {
            // removing a selected Time from selectedTimeRange then put it back to allTimeRange
            tmp.selectedTimeRange = tmp.selectedTimeRange.filter(el => el.id !== item.id)
            tmp.allTimeRange = [...tmp.allTimeRange, item]
        }
        setModalData({ ...tmp })
    }

    const dragHoverSelectedTimeBG = isOver ? "rgba(192,192,192,0.1)" : "white"
    const dragHoverAllTimeBG = isTimeRangeOver ? "rgba(192,192,192,0.1)" : "white"

    const [modalData, setModalData] = useState({
        channel: props.channel ? props.channel : null,
        warehouses: props.wareHouses ? props.wareHouses.map((element) => ({ ...element, checked: false })) : warehouses,
        selectedWarehouse: null,
        shippingCommitment: [],
        createPackageFrequency: {
            type: 'once',
            days: [8]
        },
        daysOfWeek: daysOfWeek,
        selectedTimeRange: [],
        allTimeRange: deliverTimeRange,
        createPackageTime: ['', '', '', ''],
        deliverType: [],
        warehouseLoading: false,
    })

    const [submitLoading, setSubmitLoading] = useState(false)

    useEffect(async () => {
        await unsetData()
        if (props.data) {
            await setData()
        }
    }, [props.data])

    const setData = () => {
        let tmp = modalData
        if (props.data.deliverTimeRange && props.data.deliverTimeRange.length > 0) {
            tmp.allTimeRange = tmp.allTimeRange.filter(el => !props.data.deliverTimeRange.includes(parseInt(el.id)))
            tmp.selectedTimeRange = props.data.deliverTimeRange.map(el => deliverTimeRange[el])
        }
        if (props.data.frequency && props.data.frequency.length > 0) {
            if (props.data.frequency.includes(8)) {
                tmp.createPackageFrequency.type = 'once'
                tmp.createPackageFrequency.days = [8]
            }
            if (props.data.frequency.length == 7) {
                tmp.createPackageFrequency.type = 'everyday'
                tmp.createPackageFrequency.days = [0, 1, 2, 3, 4, 5, 6]
            }
            if (props.data.frequency.length < 7 && !props.data.frequency.includes(8)) {
                tmp.createPackageFrequency.type = 'specificDays'
                tmp.createPackageFrequency.days = props.data.frequency
                tmp.daysOfWeek.map(el => {
                    if (props.data.frequency.includes(parseInt(el.value))) {
                        el.checked = true
                    }
                })
            }
        }
        if (props.data.shippingCommitment) {
            tmp.shippingCommitment = props.data.shippingCommitment
        }
        if (props.data.warehouses) {
            tmp.selectedWarehouse = props.data.warehouses
            tmp.warehouses.map(el => {
                if (props.data.warehouses.includes(el.id)) {
                    el.checked = true
                }
            })
        }
        if (props.data.deliveryType) {
            tmp.deliverType = deliverType.filter(el => el.value == props.data.deliveryType)
        }

        if (props.data.createHour) {
            let arr = (props.data.createHour.replace(':', '')).split('')
            if (arr.length < 4) {
                arr = arr.concat(['0', '0']);
            }
            tmp.createPackageTime = arr
        }
        setModalData({ ...tmp })
    }

    const unsetData = () => {
        let tmp = modalData
        tmp.selectedWarehouse = []
        tmp.shippingCommitment = []
        tmp.createPackageFrequency = {
            type: 'everyday',
            days: [0, 1, 2, 3, 4, 5, 6]
        }
        tmp.selectedTimeRange = []
        tmp.allTimeRange = deliverTimeRange
        tmp.createPackageTime = ['', '', '', '']
        tmp.daysOfWeek.map(el => {
            el.checked = false
        })
        setModalData({ ...tmp })
    }

    const handleCreateTime = (e, index) => {
        let tmp = modalData
        if (e.target.value.length < 2 && parseInt(e.target.value) <= parseInt(e.target.max) && parseInt(e.target.value) >= parseInt(e.target.min)) {
            tmp.createPackageTime[index] = e.target.value
            if (index++ < 3) {
                nameInput[index++].focus();
            }
        } else {
            tmp.createPackageTime[index] = ''
        }
        setModalData({ ...tmp })
    }

    const handleCheckBox = (e, value, tag, secondTag) => {
        let tmp = modalData
        if (tag == 'shippingCommitment') {
            if (tmp[tag].includes(secondTag)) {
                tmp[tag] = tmp[tag].filter(el => el !== secondTag)
            } else {
                tmp[tag].push(secondTag)
            }
        }
        if (tag == 'createPackageFrequency') {
            tmp[tag].type = secondTag
            tmp[tag].days = []
            if (secondTag == 'once') {
                tmp[tag].days = [8]
            }
            if (secondTag == 'everyday') {
                tmp[tag].days = [0, 1, 2, 3, 4, 5, 6]
            }
        }
        setModalData({ ...tmp })
    }

    const handleSelect = (tag, item) => {
        let tmp = modalData
        if (tag == 'days') {
            if (tmp.createPackageFrequency.days.includes(parseInt(item.value))) {
                tmp.createPackageFrequency.days = tmp.createPackageFrequency.days.filter(el => el != parseInt(item.value))
            } else {
                tmp.createPackageFrequency.days.push(parseInt(item.value))
            }
            tmp.daysOfWeek.map(el => {
                if (tmp.createPackageFrequency.days.includes(parseInt(el.value))) {
                    el.checked = true
                } else {
                    el.checked = false
                }
            })
        }

        if (tag == 'warehouse') {
            tmp.warehouses.map(el => {
                if (el.id == item.id) {
                    el.checked = !item.checked
                }
            })
            tmp.selectedWarehouse = tmp.warehouses.filter(el => el.checked == true)
        }

        if (tag == 'deliverType') {
            tmp.deliverType = [item]
            getWareHouseDataFromParent(tmp.deliverType[0].value)
        }
        setModalData({ ...tmp })
    }

    const getWareHouseDataFromParent = async (deliverType) => {
        setModalData({ ...modalData, warehouseLoading: true })
        let res = await props.getWareHouseData(deliverType)
        let tmp = modalData
        if (res && res.length > 0) {
            tmp.warehouses = res
        }
        tmp.warehouseLoading = false
        setModalData({ ...tmp })
    }

    const deleteFromSelected = tag => {
        let tmp = modalData
        if (tag == 'days') {
            tmp.createPackageFrequency.days = []
            tmp.daysOfWeek.map(el => el.checked = false)
        }
        if (tag == 'warehouse') {
            tmp.selectedWarehouse = null
        }
        if (tag == 'createPackageTime') {
            tmp.createPackageTime = [0, 0, 0, 0]
        }
        if (tag == 'deliverType') {
            tmp.deliverType = []
        }
        setModalData({ ...tmp })
    }

    const checkValidation = () => {
        let result = false;
        if (modalData.createPackageFrequency.type != '' && modalData.createPackageFrequency.days.length > 0 && modalData.createPackageTime.length > 0
            && modalData.selectedTimeRange.length > 0 && modalData.selectedWarehouse && modalData.shippingCommitment.length > 0) {
            result = true;
            modalData.createPackageTime.map(el => {
                if (el == '') {
                    result = false
                }
            })
        }
        return result;
    }

    const createCargofunction = async () => {
        setSubmitLoading(true)
        let createPackageTimeTmp = modalData.createPackageTime[0] != '' ? (((modalData.createPackageTime).toString()).replaceAll(',', '')).slice(0, 2) + ':' + (((modalData.createPackageTime).toString()).replaceAll(',', '')).slice(2) : "00:00"
        let reqObject = {
            channelId: modalData.channel ? modalData.channel._id : null,
            shippingCommitment: modalData.shippingCommitment,
            frequency: modalData.createPackageFrequency.days,
            warehouses: modalData.selectedWarehouse,
            deliverTimeRange: modalData.selectedTimeRange.length > 0 ? modalData.selectedTimeRange.map(el => el.id) : [],
            createHour: createPackageTimeTmp,
            deliveryType: modalData.deliverType[0].value,
            natureType: props.natureType
        }
        let type = 'create'
        if (props.data) {
            type = 'edit'
            reqObject.configId = props.data._id
        }
        await props.createCargofunction(reqObject, type)
        setSubmitLoading(false)
    }

    return (
        <>
            <div className={style.wrapper}>
                <div className={style.itemBox}>
                    <div className={style.title}>تعهد ارسال</div>
                    <div className={style.checkBoxWrapper}>
                        {shippingCommitment.map((comitment, index) => <CheckBox
                            key={index}
                            value={modalData.shippingCommitment.includes(comitment.value) ? true : false}
                            tag='shippingCommitment'
                            secondTag={comitment.value}
                            label={comitment.name}
                            onclick={handleCheckBox}
                        />)}
                    </div>
                </div>


                <div className={style.itemBox}>
                    <div className={style.title}>تکرار ساخت محموله</div>
                    <div className={style.radioButtonWrapper}>
                        {createPackageFrequency.map((frequency, index) => <div
                            key={index}
                            className={style.radioWrapper}
                        >
                            <RadioButton
                                value={modalData.createPackageFrequency.type == frequency.value ? true : false}
                                tag='createPackageFrequency'
                                secondTag={frequency.value}
                                label={frequency.name}
                                onclick={handleCheckBox}
                            />
                        </div>)}
                    </div>
                </div>

                {modalData.createPackageFrequency.type == 'specificDays' && <div className={style.itemBoxDropdown}>
                    <div className={style.title}>انتخاب روز</div>
                    <div className={style.dropDownWrapper}>
                        <DropDown
                            tag='days'
                            label=''
                            placeHolder={modalData.createPackageFrequency.days.length > 0 ? null : 'انتخاب روز'}
                            value={modalData.createPackageFrequency.days.length > 0 ? modalData.createPackageFrequency.days.map((el, index) => modalData.daysOfWeek[el].name) : null}
                            placeHolderStyle='#999'
                            dropdownList={modalData.daysOfWeek}
                            hasCheckbox={true}
                            handleSelect={handleSelect}
                            onblure={() => { }}
                            deleteSelectedItems={deleteFromSelected}
                            errorMessage=''
                        />
                    </div>
                </div>}

                <div className={style.itemBoxDropdown}>
                    <div className={style.title}>
                        <div className={style.createHourFlex}>
                            <p>ساعت ساخت محموله</p>
                        </div>
                    </div>

                    <div className={style.createHourWrapper}>
                        <input
                            className={style.inputWrapper}
                            onChange={(e) => handleCreateTime(e, 0)}
                            min={0}
                            max={2}
                            value={toPersianNumber(modalData.createPackageTime[0])}
                            ref={(input) => {
                                nameInput[0] = input;
                            }}
                        />
                        <input
                            className={style.inputWrapper}
                            onChange={(e) => handleCreateTime(e, 1)}
                            min={0}
                            max={9}
                            value={toPersianNumber(modalData.createPackageTime[1])}
                            ref={(input) => {
                                nameInput[1] = input;
                            }}
                        />
                        :
                        <input
                            className={style.inputWrapper}
                            onChange={(e) => handleCreateTime(e, 2)}
                            min={0}
                            max={5}
                            value={toPersianNumber(modalData.createPackageTime[2])}
                            ref={(input) => {
                                nameInput[2] = input;
                            }}
                        />
                        <input
                            className={style.inputWrapper}
                            onChange={(e) => handleCreateTime(e, 3)}
                            min={0}
                            max={9}
                            value={toPersianNumber(modalData.createPackageTime[3])}
                            ref={(input) => {
                                nameInput[3] = input;
                            }}
                        />
                    </div>
                </div>

                <div className={style.itemBoxDropdown}>
                    <div className={style.title}>
                        <div className={style.createHourFlex}>
                            <p>روش تحویل</p>
                        </div>
                    </div>
                    <div className={style.dropDownWrapper}>
                        <DropDown
                            tag='deliverType'
                            label=''
                            placeHolder={'انتخاب روش تحویل'}
                            placeHolderStyle='#ccc'
                            value={modalData.deliverType.length > 0 ? modalData.deliverType.map(a => a.name) : null}
                            dropdownList={deliverType}
                            handleSelect={handleSelect}
                            onblure={() => { }}
                            deleteSelectedItems={deleteFromSelected}
                            errorMessage=''
                        />
                    </div>
                </div>

                {(props.wareHouses.length > 0 && !modalData.warehouseLoading) || (modalData.selectedWarehouse != null && modalData.selectedWarehouse.length > 0 && !modalData.warehouseLoading) ?
                    <div className={style.itemBoxDropdown}>
                        <div className={style.title}>
                            <div className={style.createHourFlex}>
                                <p>انتخاب انبار</p>
                                <span className={style.tooltipWrapper}>
                                    <Tooltip
                                        direction='ًRight'
                                        text={`انبارها به ترتیب انتخاب شما، الویت‌بندی می‌شوند.`}
                                    />
                                </span>
                            </div>
                        </div>
                        <div className={style.dropDownWrapper}>
                            <DropDown
                                tag='warehouse'
                                label=''
                                placeHolder={'انتخاب انبار'}
                                placeHolderStyle='#ccc'
                                value={modalData.selectedWarehouse != null ? modalData.selectedWarehouse.map(a => a.name) : null}
                                dropdownList={modalData.warehouses}
                                hasCheckbox={true}
                                handleSelect={handleSelect}
                                onblure={() => { }}
                                deleteSelectedItems={deleteFromSelected}
                                errorMessage=''
                            />
                        </div>
                    </div>
                    :
                    <div className={style.itemBoxDropdown} style={{ opacity: '0.5' }}>
                        <div className={style.title}>
                            <div className={style.createHourFlex}>
                                <p>انتخاب انبار</p>
                                <span className={style.tooltipWrapper}>
                                    <Tooltip
                                        direction='ًRight'
                                        text={``}
                                    />
                                </span>
                            </div>
                        </div>
                        <div className={style.dropDownWrapper}>
                            <input className={style.fakeDropdown} placeholder="انتخاب انبار" disabled={true}></input>
                        </div>
                    </div>
                }

                <div className={style.itemBox}>
                    <div className={style.title}>بازه زمانی تحویل</div>
                    <div className={style.timeRangeWrapper}>
                        <div className={style.innerFlexBox}>
                            <div className={style.dragBox}>
                                <div className={style.dragTitle}>بازه‌ی زمانی انتخابی به ترتیب اولویت</div>
                                {/* **********drop items************ */}
                                <div
                                    className={style.dropItemsArea}
                                    style={{ background: dragHoverSelectedTimeBG }}
                                    ref={addToTimeRangeRef}
                                >
                                    {modalData.selectedTimeRange.length > 0 && modalData.selectedTimeRange.map((selected, index) => <TimeCard
                                        key={index}
                                        index={index}
                                        data={selected}
                                        type="selectedTimeRange"
                                        onDropTimeRange={moveTimeRange}
                                    />)}
                                </div>
                            </div>
                            <div className={style.partition}>
                                <div className={style.line}>
                                    <div className={style.circle}><span className={style.dragIcon}></span></div>
                                </div>
                            </div>
                            <div className={style.dragBox}>
                                <div className={style.dragTitle}>همه‌ی بازه‌های زمانی</div>
                                {/* **********drag items************ */}
                                <div
                                    className={style.dropItemsArea}
                                    style={{ background: dragHoverAllTimeBG }}
                                    ref={removeFromTimeRangeRef}
                                >
                                    {modalData.allTimeRange.map((time, index) => <TimeCard
                                        key={index}
                                        index={index}
                                        data={time}
                                        type="allTimeRange"
                                        onDropTimeRange={moveTimeRange}
                                    />)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={style.buttonWrapper}>
                    <div className={style.buttonItem}>
                        <Button
                            disabled={checkValidation() ? false : true}
                            loading={submitLoading}
                            tag='submit'
                            type="solid"
                            label="ثبت تنظیمات"
                            onclick={() => createCargofunction()}
                        />
                    </div>
                    <div className={style.buttonItem}>
                        <Button
                            disabled={false}
                            tag='cancel'
                            type="outline"
                            label="انصراف"
                            onclick={props.closeModal}
                        />
                    </div>
                </div>
            </div>
            {/*  <div className={style.dropDownWrapper}>
                        <DropDown
                            tag='createPackageTime'
                            label=''
                            placeHolder={modalData.createPackageTime != '' ? null : 'ساعت ساخت محموله'}
                            placeHolderStyle='#ccc'
                            value={modalData.createPackageTime != '' ? toPersianNumber(modalData.createPackageTime.name) : null}
                            dropdownList={createPackageTime}
                            hasCheckbox={false}
                            handleSelect={handleSelect}
                            onblure={() => { }}
                            deleteSelectedItems={deleteFromSelected}
                            errorMessage=''
                        />
        </div>*/}
        </>
    );
}

export default CargoModalTab;
